import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

export const fetchBookmarks = createAsyncThunk(
    "bookmarks/fetch",
    async (token) => {
        const res = await fetch(`${process.env.REACT_APP_API_URL}/api/bookmarks`, {
            headers: { Authorization: `Bearer ${token}` },
        });
        return await res.json();
    }
);

export const addBookmark = createAsyncThunk(
    "bookmarks/add",
    async ({ couponId, token }) => {
        await fetch(`${process.env.REACT_APP_API_URL}/api/bookmarks`, {
            method: "POST",
            headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
            body: JSON.stringify({ coupon_id: couponId }),
        });
        return couponId;
    }
);

export const removeBookmark = createAsyncThunk(
    "bookmarks/remove",
    async ({ couponId, token }) => {
        await fetch(`${process.env.REACT_APP_API_URL}/api/bookmarks/${couponId}`, {
            method: "DELETE",
            headers: { Authorization: `Bearer ${token}` },
        });
        return couponId;
    }
);

const bookmarkSlice = createSlice({
    name: "bookmarks",
    initialState: {
        bookmarks: [],
        bookmarkedIds: [],
        status: "idle",
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchBookmarks.pending, (state) => { state.status = "loading"; })
            .addCase(fetchBookmarks.fulfilled, (state, action) => {
                state.bookmarks = Array.isArray(action.payload) ? action.payload : [];
                state.bookmarkedIds = state.bookmarks.map((b) => b.id);
                state.status = "succeeded";
            })
            .addCase(fetchBookmarks.rejected, (state) => { state.status = "failed"; })
            .addCase(addBookmark.fulfilled, (state, action) => {
                if (!state.bookmarkedIds.includes(action.payload)) {
                    state.bookmarkedIds.push(action.payload);
                }
            })
            .addCase(removeBookmark.fulfilled, (state, action) => {
                state.bookmarkedIds = state.bookmarkedIds.filter((id) => id !== action.payload);
                state.bookmarks = state.bookmarks.filter((b) => b.id !== action.payload);
            });
    },
});

export default bookmarkSlice.reducer;
